var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('loyalty-customer-search',{on:{"input":_vm.onCustomerSelected}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }